export const generalData = {
  aiName: '',
  intro: '',
};

export const basicData = {
  companyUrl: '',
  businessCategoryOptions: [],
  businessCategory: [],
  companyDescription: '',
  emailId: '',
};

export const signalData = {
  CUSTOM_AI_SIGNAL: [],
};

export const knowledgeBaseData = {
  URLS: [],
  PDFS: [],
  PPTS: [],
};

export const conversationSetupData = {
  data: [],
};

export const defaultData = {
  GENERAL: generalData,
  BASIC: basicData,
  SPROUTS_SIGNAL: signalData,
  KNOWLEDGE_BASE: knowledgeBaseData,
  CONVERSATION: conversationSetupData,
};

export const mappings = {
  GENERAL: 'general',
  BASIC: 'basicSetup',
  SPROUTS_SIGNAL: 'sproutsSignals',
  KNOWLEDGE_BASE: 'knowledgeBase',
  CONVERSATION: 'conversationSetup',
};
